import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { getProductInventoryMinimium } from "../../services/dashboards";

export default function DashboardMinExistenciasChart({ inventarioSelected }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!inventarioSelected) return;
    const fetchData = async () => {
      try {
        const result = await getProductInventoryMinimium({ inventario: inventarioSelected });
        setData(result.top_menos_existencias);
      } catch (err) {
        console.error("Error cargando mínimos:", err);
      }
    };
    fetchData();
  }, [inventarioSelected]);

  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <h3 className="text-lg font-semibold mb-2 text-gray-700">Top 30 con menos existencias</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical" margin={{ left: 50 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis type="category" dataKey="nombre" width={150} />
          <Tooltip />
          <Bar dataKey="cantidad" fill="#dc2626" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
